module.exports = __webpack_public_path__ + "static/img/Delhi NCR.6c93166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Delhi NCR.png
// module id = 1SNC
// module chunks = 12